import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const removeAlarmDeploymentAPI = async (deviceId, t, successText) => {
  await axios({
    url: `/api/v2/alarm/deploy/delete`,
    method: "DELETE",
    data: {
      device_id: deviceId
    }
  });
  successHandling(t, successText);
  return true;
};
